import React, { useState, useEffect } from "react";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import PDFExpenseReport from './PDFExpenseReport'

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
				width: 100
			  },	
		  '&:nth-child(2)': {
			width: 200
		  },
		  '&:nth-child(3)': {
			width: 200
		  },
		  '&:nth-child(4)': {
			width: 400
		  }
		}
	  }
	}
  });

const ExpenseReport = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const [grandTotal, setGrandTotal] = useState({"grand_total":0});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const DownloadPdf = ( {data, grandTotal} ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFExpenseReport data={data} grandTotal={grandTotal} dateFrom={format(dateRange.startDate, "MM-dd-yyyy")} dateTo={format(dateRange.endDate, "MM-dd-yyyy")} />} 
			fileName={"expense-report"}>
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
            process.env.REACT_APP_API_URL+'expense_report', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        })
		setPosts(result.data.data);
		// console.log(result.data.data)
		if(result.data.data.length > 0){
			const grandTotal = result.data.data.pop();
			if(grandTotal.grand_total){
				setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
			}
		}
		setDataLoaded(true);
    }

	const data = async () => {
		// const res = await axios.get(
		// process.env.REACT_APP_API_URL+'expense_report', {
        //     params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/12/01/',   
        //         jc_user_id_no: 'DAVAOHQ',  
        //     }
        // })	
		// setPosts(res.data.data);
		// setPosts(res.data.data);
		// if(res.data.data.length > 0){
		// 	const grandTotal = res.data.data.pop();
		// 	if(grandTotal.grand_total){
		// 		setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
		// 	}
		// }
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	// "acctid": 25,
	// "payto": "",
	// "totalamt": "2,950.00"
	// "grand_total": "822,873.43"
	const columns = [
		{
			name: "acctid",
			label: "Account ID",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "acctdescription",
			label: "Account Name",
		},
		{
			name: "acctbranch",
			label: "Account Branch",
		},
		{
			name: "totalamt",
			label: "Total Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
							// <div>{numeral(value).format('0,0.00')}</div>
					);
				  }
			}
		},
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: false,  //add this
		print: false,
		viewColumns:false, //add this
		downloadOptions: {
			filename : 'ExpenseReport.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem'
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Expense Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={4} lg={3} xl={2}>
							<TextField
								id="outlined-basic"
								label="Select Date"
								variant="outlined"
								onFocus={() => setOpen(true)}
								autoComplete="off"
								fullWidth={true}
								value={`${format(
									dateRange.startDate,
									"MM/dd/yyyy"
								)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
							/>
							<DateRangePicker
								open={open}
								toggle={toggle}
								onChange={(range) => dateRangeHandler(range)}
							/> 
						</Grid>

						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "23px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}
						<Grid item xs={3} sm={2}>
							<Button style ={{marginTop: "23px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
						<Grid item xs={9} sm={6} md={8} style={{ display: "flex", justifyContent: "flex-end" }}>
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  style={{marginTop: '5px', marginLeft: '20px'}} 
								  id="outlined"
								  type="text"
								  value={grandTotal.grand_total}
								  variant="outlined"
								  label="Grand Total"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
						</Grid>	
					</Grid>       

				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style ={{color: "#339933"}}>
									 Expense Report
									</h3>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
					</MuiThemeProvider>	
				)}

				<Grid
					container
					direction="row"
					justifyContent="flex-end"
					alignItems="center"
					style={{marginTop: '1rem', justifyContent: 'flex-end'}}
				>
					<div>
						{
							grandTotal.grand_total  ?
							<DownloadPdf 
								data 		= {posts}
								grandTotal 	= {grandTotal.grand_total}
							/>
							: ""
						}
					</div>
				</Grid>
			</div>
		</div>
	);
};

export default ExpenseReport;
